var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 75,
    viewBox: "0 0 164 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0467 30.1774C30.873 26.2059 29.381 23.3593 26.7184 21.4998C24.2854 19.8699 21.2096 19.6403 17.9502 21.2473L4.40763 27.3538C1.01051 28.8919 -0.458512 32.8634 1.01051 36.1921C2.5484 39.5897 6.45049 41.0589 9.84761 39.5897L11.638 38.7632L8.72289 54.6034C7.89657 59.3783 10.9953 63.281 15.2187 64.1074C19.6947 64.9339 24.0558 61.9954 24.7903 57.5189L30.0467 30.1774Z",
    fill: "url(#paint0_linear_1_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.238 20.329C145.778 19.2501 138.25 23.6118 135.38 29.7642L135.862 27.0783C137.079 21.6376 134.807 20.1913 130.927 20.1913H125.901C121.126 20.1913 120.047 22.7854 119.474 25.7927L113.62 58.2535C113.138 60.4573 113.46 64.2681 117.752 64.2681H124.73C128.862 64.2681 129.665 61.0312 130.239 57.9321L133.062 42.3445C133.728 38.7862 134.279 37.0645 135.495 35.7559C137.354 33.6439 141.096 32.6797 143.69 34.7917C145.227 36.0773 145.801 38.2812 145.388 41.3803L142.565 58.2535C141.945 61.9954 143.529 64.2681 146.628 64.2681H153.605C157.576 64.2681 158.38 61.1919 158.954 57.9321L163.039 36.789C164.944 29.1673 162.259 21.6376 153.238 20.329Z",
    fill: "url(#paint1_linear_1_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.502 15.9673C112.939 15.9673 116.536 12.4008 116.536 8.00129C116.536 3.6018 112.939 0.0353165 108.502 0.0353165C104.065 0.0353165 100.468 3.6018 100.468 8.00129C100.468 12.4008 104.065 15.9673 108.502 15.9673Z",
    fill: "url(#paint2_linear_1_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.007 57.8862C108.433 61.2838 107.469 64.2222 103.498 64.2222H96.4512C93.0541 64.2222 91.8146 61.697 92.4802 58.3683L98.2645 25.7468C98.8384 22.2574 100.376 20.1454 104.692 20.1454H110.04C114.584 20.1454 115.709 22.3492 114.745 27.0324L109.007 57.8862Z",
    fill: "url(#paint3_linear_1_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4698 20.1454C33.2602 22.2574 35.3719 24.8515 34.2931 31.1875L31.5387 46.0635L32.0207 58.001C32.1125 62.3168 34.2242 64.1763 37.782 64.1763H46.8716C49.6949 64.1763 50.9344 61.9725 52.0591 59.2406L58.9452 42.2756L59.6797 58.506C59.7715 62.0643 61.5389 64.2681 64.8672 64.2681H75.1733C78.0884 64.2681 79.3049 62.4775 80.6133 59.3324L93.8345 26.8717C95.2806 23.543 94.4083 20.2142 90.8276 20.2142H84.2399C81.8069 20.2142 80.1083 21.0407 79.1213 23.3823L70.1924 45.0993L69.3661 25.7009C69.2054 21.5687 67.2543 20.1913 64.8901 20.1913H58.1647C55.4792 20.1913 53.9413 21.2473 53.1379 23.2675L44.209 45.1911L43.3827 25.2188C43.2909 21.4769 42.0055 20.1913 38.9986 20.1913H33.2602H31.4698V20.1454Z",
    fill: "url(#paint4_linear_1_4)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4",
    x1: 15.3517,
    y1: 70.3176,
    x2: 15.3517,
    y2: 19.1202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0167CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38A8FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_4",
    x1: 138.558,
    y1: 65.3916,
    x2: 138.558,
    y2: 19.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0762789,
    stopColor: "#D6D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3802,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_4",
    x1: 108.504,
    y1: 20.0223,
    x2: 108.504,
    y2: -2.73076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0167CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38A8FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_4",
    x1: 63.0184,
    y1: 65.3891,
    x2: 63.0184,
    y2: 19.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0762789,
    stopColor: "#D6D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3802,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_4",
    x1: 63.0184,
    y1: 65.3891,
    x2: 63.0184,
    y2: 19.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0762789,
    stopColor: "#D6D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3802,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5898,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bad744f59582b84c8d9f4b54c80d9702.svg";
export { ForwardRef as ReactComponent };